export enum OmnisoftCheckTypeEnum {
    LOGIN = 40,
    SALE = 1,
    OPEN_SHIFT = 15,
    CLOSE_SHIFT = 13,
    ROLLBACK = 10

    //        7 – Deposit
    //1 – Sale
    //16 – Re-print after printing error
    //10 – Rollback
    //100 – Money back
    //8 – Withdraw
    //19 – Correction
    //31- Credit Pay
    //32 – Credit Rollback
    //100 – Credit Moneyback
    //34 – Prepay

}